import React from 'react';

/**
 * Primary context for sites. Provides three keys:
 *   market: outdoor|urban|leaf
 *   country: ca|us|de|...
 *   language: en|fr|es|...
 *
 * All values are expected to be lowercase.
 */
const SiteContext = /*#__PURE__*/React.createContext({});
const SiteContextProvider = _ref => {
  let {
    children,
    market,
    country,
    language
  } = _ref;
  return /*#__PURE__*/React.createElement(SiteContext.Provider, {
    value: {
      market,
      country,
      language
    }
  }, children);
};
const SiteContextConsumer = SiteContext.Consumer;

/**
 * Context for seasonality. Provides two keys:
 *   year: 19|20|21|...
 *   season: F|S
 *
 * Note that we could redefine the acceptable values for these keys to accommodate
 * more seasons in the future. For example season could accept: spring, summer, fall, winter.
 */
const SeasonalContext = /*#__PURE__*/React.createContext({});
const SeasonalContextProvider = _ref => {
  let {
    children,
    year,
    season
  } = _ref;
  return /*#__PURE__*/React.createElement(SeasonalContext.Provider, {
    value: {
      year,
      season
    }
  }, children);
};
const SeasonalContextConsumer = SeasonalContext.Consumer;

export { SeasonalContext, SeasonalContextConsumer, SeasonalContextProvider, SiteContext, SiteContextConsumer, SiteContextProvider };
//# sourceMappingURL=index.js.map
